import { useAppDispatch } from "../../hooks/useAppDispatch";
import { util } from "../../store/user/user.api";

export const useUpdateUnviewedChatMessages = () => {
    const dispatch = useAppDispatch();

    return (unviewedChatMessagesCount: number) => {
        const isValidCount =
            typeof unviewedChatMessagesCount === "number" &&
            !isNaN(unviewedChatMessagesCount);

        if (!isValidCount) return;

        dispatch(
            util.updateQueryData("getProfile", undefined, (profile) => {
                profile.unviewed_chat_messages_order_all_count =
                    unviewedChatMessagesCount;
            })
        );
    };
};
